import { render, staticRenderFns } from "./DataHistorian.vue?vue&type=template&id=4806285b"
import script from "./DataHistorian.vue?vue&type=script&lang=js"
export * from "./DataHistorian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports